import PropTypes from "prop-types"
import { Link } from "react-router-dom"
import styled from "styled-components"

import {
  Content,
  LinkButton,
  SearchBox,
  SubTitle,
  ReadmoreLink,
} from "areas/helpdesk/index"
import Loading from "areas/helpdesk/loading"
import { Box, Flex, Typography } from "components/common/index"
import withHelpdesk from "hoc/helpdesk/with-helpdesk"

const Title = styled(Typography).attrs(() => ({
  as: "h1",
}))`
  ${({ theme }) => `
    color: ${theme.colors.black};
    font-size: 24px;
    font-weight: 700;
    line-height:29px;

  `}
`
const SearchResults = ({ searchResults, searchValue }) => {
  if (!searchResults.page) {
    return <Loading />
  }

  return (
    <>
      <Title ml={{ _: 2, tablet: 0 }} my={{ _: 1, tablet: 4 }}>
        Results for &quot;{searchValue}&quot;
      </Title>
      <Flex
        addYPadding
        flexDirection={{ _: "column", tablet: "row" }}
        flexWrap="wrap"
        gutter={{ _: 0, tablet: 3 }}
      >
        {searchResults.items && searchResults.items.length > 0 ? (
          searchResults.items.map((article, index) => (
            <Box
              as={Link}
              data-lc="search-results"
              display="flex"
              flex={{ _: 1, tablet: "0 0 50%" }}
              key={`article_${index}`}
              to={`/helpdesk/a/${article.number}/${article.slug}`}
            >
              <SearchBox
                minHeight={{ _: "160px", tablet: "300px" }}
                my={{ _: 1, tablet: 0 }}
                padding={{ _: "32px", tablet: "48px" }}
              >
                <Box height="90%">
                  <SubTitle>{article.name.toUpperCase()}</SubTitle>
                  <Content my={3}>{article.preview}</Content>
                </Box>
                <ReadmoreLink>Keep Reading</ReadmoreLink>
              </SearchBox>
            </Box>
          ))
        ) : (
          <Box>
            <Typography fontSize={20} fontWeight="bold" textAlign="center">
              No search results found
            </Typography>
          </Box>
        )}
      </Flex>
      <Box textAlign="center">
        <LinkButton
          as={Link}
          data-lc="search-results"
          display="inline-block"
          my={{ _: 4, tablet: 6 }}
          to="/helpdesk"
        >
          BACK TO HOME
        </LinkButton>
      </Box>
    </>
  )
}

SearchResults.propTypes = {
  searchResults: PropTypes.object,
  searchValue: PropTypes.string,
}

export default withHelpdesk(SearchResults)
